import React from 'react';
import Feature from '../../components/feature/Feature';
import './features.css';

const featuresData = [
  {
    title: 'User Registration and Profile Management',
    text: 'Users, including SPOs, NFT Project Leads, Marketers, and Large Capital Delegators, can register and sign in to AdaLink. SPOs can edit their profiles to provide necessary information for affiliates.',
  },
  {
    title: 'Affiliate Interaction',
    text: 'NFT Project owners and whales (referred to as allies) register and set up their profiles.',
  },
  {
    title: 'NFT Tracking',
    text: 'AdaLink will monitor NFT policy IDs and wallets, which will allow the platform to provide precise estimates of potential commission rewards for affiliates and potential additional incoming delegation for SPOs. Additionally, this tracking system will serve as the basis for performance evaluation and reward distribution, ensuring that all parties are compensated fairly and transparently based on their contributions.',
  },
  {
    title: 'Reward Distribution',
    text: "At the end of every epoch, AdaLink will calculate the exact amount of new incoming delegation resulting from each affiliate's promotional work. The platform will then automatically allocate commission rewards accordingly. Affiliates will claim these rewards through the platform, ensuring a transparent and accountable reward distribution process.",
  },
  {
    title: 'User Dashboards',
    text: "Each user will have a personalized dashboard to manage their interactions and track their performance. These dashboards will display key information such as partnership status, detailed information about each SPO partnership, outgoing offers, and the rewards status of current partnerships. Affiliates will have access to performance analytics, enabling them to monitor the effectiveness of their promotional efforts and adjust strategies as needed. In the future, AdaLink aims to evolve into a hub center for dApps plugins, providing a range of related services to our users, further enhancing the platform's utility and user experience.",
  },
  {
    title: 'Referral Link Provision',
    text: 'Initially, AdaLink will focus on servicing affiliates who already have their own NFT collections and whales. We will provide these affiliates with unique referral links that they can share on their platforms to attract delegation to their partner SPOs.',
  },
];

const Features = (props) => (
  <div className='gpt3__features'>
    <div className="gpt3__features-card gradient__card section__margin" id="workflow">
      <div className="gpt3__features-heading">
        <h1 className="gradient__text">AdaLink Workflow</h1>
      </div>
      <div className="gpt3__features-container">
        {featuresData.map((item, index) => (
          <Feature title={item.title} text={item.text} key={item.title + index} />
        ))}
      </div>
      <div className='gpt3__features-heading'>
        <p onClick={() => props.setMiddleWindowTrigger(true)}>Get started by signing up</p>
      </div>
    </div>
  </div>

);

export default Features;